const delayedExecution = (func) => {
    setTimeout(() => {
        func();
    }, 600);
}

export default delayedExecution;